export default __webpack_public_path__ + "static/suede-d9f75b4838d40a4d91ce292d9bc11d61.jpg";